import { Flex } from '@chakra-ui/layout'
import { type APIUser } from '../api'
import { useUserAwareTranslation } from '../i18n/hooks'
import { ButtonTab } from './Base'

// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
function doNothing(_user: APIUser, _languageCode: string): void {}

interface Language {
  code: string
  label: string
}
export type ChangeLanguageHandler = (user: APIUser, languageCode: string) => void
interface ChangeLanguageProps {
  isActive: boolean
  languages: Language[]
  user: APIUser
  changeLanguageHandler: ChangeLanguageHandler
}
const ChangeLanguage = (props: ChangeLanguageProps) => {
  const { isActive = false, languages, user, changeLanguageHandler = doNothing } = props

  const { i18n } = useUserAwareTranslation(user)

  const transformLanguageCode = (languageCode: string) => {
    return languageCode
      .split('_')
      .map((part, index) => (index === 1 ? part.toUpperCase() : part))
      .join('-')
  }

  const resultTransformLanguageCode = transformLanguageCode(i18n.language)

  return isActive ? (
    <Flex
      flexDirection="row"
      justifyContent="flex-end"
      gap="2"
      borderBottom="1px solid"
      borderBottomColor="gray.200">
      {languages.map((language) => (
        <ButtonTab
          key={language.code}
          size={{ base: 'md', md: 'sm' }}
          isActive={resultTransformLanguageCode === language.code}
          onClick={() => {
            changeLanguageHandler(user, language.code)
          }}>
          {language.label}
        </ButtonTab>
      ))}
    </Flex>
  ) : null
}

export default ChangeLanguage
